import styled from 'styled-components';
import { RowColumn } from '../styles';
import { layout, media } from '@prisjakt/ui-base';

interface IPromoted {
  isPromoted: boolean;
}

export const StoreLogoColumn = styled(RowColumn)`
  min-width: 113px;
  margin-right: 0;
`;

export const ProductNameColumn = styled(RowColumn)`
  text-align: left;
  flex-grow: 1;
  align-items: center;
`;

export const PriceColumn = styled(RowColumn)`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  margin: ${layout.spacing.xxSmall};
`;

export const PriceColumnRow = styled.div`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  align-items: baseline;
  text-align: right;
  justify-content: end;
`;

export const GoToStoreColumn = styled(RowColumn)<IPromoted>`
  margin: 0 ${layout.spacing.xSmall} 0 ${layout.spacing.xxSmall};
  align-self: center;
  color: ${props => {
    return props.isPromoted
      ? props.theme.buttons.primary.bg
      : props.theme.buttons.positive.bg;
  }};

  display: flex;

  ${media.largeUp`
    button,
    button:hover,
    button:focus {
      background: ${props => props.theme.buttons.primary.bg};
    }`}
`;
